import GUI_Header from "./GUI_Header";
import GUI_InputTextSingle from "./GUI_InputTextSingle";
import GUI_Credit from "./GUI_Credit";
import GUI_Select from "./GUI_Select";
import GUI_InputTextArea from "./GUI_InputTextArea";
import GUI_2Buttons from "./GUI_2Buttons";

import T from "../TheTool";

function GUIset_1Text1Combo1MultiLine(props) {

	var title1 = T.getValue(props.title, "");
	var desc1 = T.getValue(props.desc, "");
	var centerDesc = T.getValue(props.centerDesc, false);
	//
	var width1 = T.getValue(props.width1, 100);
	var width2 = T.getValue(props.width2, "100%");
	//
	var comboFist = T.getValue(props.comboFist, false);
	//Textbox
	var guiTxt1 = T.getValue(props.guiTxt, "");
	var label1 = T.getValue(props.label1, "Input");
	var guiTxtChange1 = props.guiTxtChange;
	var isNumOnly = T.getValue(props.isNumOnly, false);
	var label1Align = T.getValue(props.label1Align, "left");
	//Selector
	var label2 = T.getValue(props.label2, "");
	var paddingR2 = T.getValue(props.paddingR2, 0);
	var selecter_option = props.selecter_option;
	var selectedOption = props.selectedOption;
	var setSelectedOption = props.setSelectedOption;
	//Area
	var labelArea = T.getValue(props.labelArea, "");
	var labelArea2 = T.getValue(props.labelArea2, "");
	var guiTxtArea = T.getValue(props.guiTxtArea, "");
	var guiTxtAreaChange = props.guiTxtAreaChange;
	var guiTxtAreaPlaceholder= T.getValue(props.guiTxtAreaPlaceholder, "");
	//Button
	var but1_label = T.getValue(props.but1_label, "");
	var but2_label = T.getValue(props.but2_label, "");
	var but1_ratio = T.getValue(props.but1_ratio, 1);
	var but2_ratio = T.getValue(props.but2_ratio, 3);
	var buttonClick1 = props.buttonClick1;
	var buttonClick2 = props.buttonClick2;

	
	//oth
	var txtButton = T.getValue(props.txtButton, "Click");
	//----------------------------------
	var InputTxt1 = <GUI_InputTextSingle
			label={label1}
			text1={guiTxt1}
			width1={width1}
			width2={width2}
			text1Change={guiTxtChange1}
			numberOnly={isNumOnly}
			fontSize2={24}
			labelAlign={label1Align}
		/>
	;
	var Selecter1 = <GUI_Select
			label={label2}
			width1={width1}
			selecter_option={selecter_option}
			selectedOption={selectedOption}
			setSelectedOption={setSelectedOption}
			paddingR={paddingR2}
		/>
	;
	//----------------------------------

	
	const area1Change = (event) => {
		props.area1Change(event.target.value);
	};
			
	return (
		<div className="todoapp stack-large">
			<GUI_Header title={title1} desc={desc1} centerDesc={centerDesc} />
			<div style={{ marginTop: "3em" }}> </div>
			{comboFist ? (<div>{Selecter1}{InputTxt1}</div>) : (<div>{InputTxt1}{Selecter1}</div>)}			
			<div style={{ marginTop: "2em" }}> </div>
			<GUI_InputTextArea
				id="inputItemList"
				className="textarea_001"
				placeholder={guiTxtAreaPlaceholder}
				style={{ minHeight: "308px", whiteSpace: "pre-line" }}
				area1Change={guiTxtAreaChange}
				text1={guiTxtArea}
				label={labelArea}
				label2={labelArea2}
				fontSize1={18}
			/>
			<div style={{ marginTop: "2em" }}> </div>
			<GUI_2Buttons
				buttonClick1={buttonClick1}
				buttonClick2={buttonClick2}
				label1={but1_label}
				label2={but2_label}
				ratio1={but1_ratio}
				ratio2={but2_ratio}
			/>
			<div style={{ marginTop: "3em" }}> </div>
			{props.partResult}
			<GUI_Credit />
		</div>
	);
}
export default GUIset_1Text1Combo1MultiLine;
